document.documentElement.className = 'js';
(function (window) {
    'use strict';
    Vue.prototype.$first = function (item, list) {
        return item === list[0]
    };
    var vm = new Vue({
        el: "#vue-search",
        data: {
            topic: "",
            autocompleteResults: {}
        },
        updated: function () {
            var sEpicaAnchors = document.querySelectorAll('#vue-search[data-epica-module-name] a[href]');
            sEpicaAnchors.forEach(function (el) {
                el.addEventListener('click', epicaClick);
            });
        },
        methods: {
            autocomplete: _.debounce(function () {
                if (this.topic) {
                    this.$http.get('/api/ac/' + this.topic).then(function (response) {
                        this.autocompleteResults = response.body;
                    }, function (response) {

                    });
                }
                else {
                    this.autocompleteResults = {};
                }
            }, 200)
        }
    });


    var vm2 = new Vue({
        el: "#vue-search-mobile",
        data: {
            topic: "",
            autocompleteResults: {}
        },
        updated: function () {
            var sEpicaAnchors = document.querySelectorAll('#vue-search-mobile[data-epica-module-name] a[href]');
            sEpicaAnchors.forEach(function (el) {
                el.addEventListener('click', epicaClick);
            });
        },
        filters: {
            limit: function (arr, limit) {
                return arr.slice(0, Number(limit))
            }
        },
        methods: {
            autocomplete: _.debounce(function () {
                if (this.topic) {
                    this.$http.get('/api/ac/' + this.topic).then(function (response) {
                        var b = response.body;
                        b.posts = b.posts.slice(0, 4);
                        this.autocompleteResults = b;
                    }, function (response) {

                    });
                }
                else {
                    this.autocompleteResults = {};
                }
            }, 200)
        }
    });

    var mainContainer = document.querySelector('.main-wrap'),
        openCtrl = document.querySelectorAll('.open-search'),
        closeCtrl = document.getElementById('btn-search-close'),
        searchContainer = document.querySelector('.search'),
        inputSearch = searchContainer.querySelector('.search__input');

    function init() {
        initEvents();
    }

    function initEvents() {
        for (var i = 0; i < openCtrl.length; i++) {
            openCtrl[i].addEventListener('click', openSearch);
        }
        closeCtrl.addEventListener('click', closeSearch);
        document.addEventListener('keyup', function (ev) {
            // escape key.
            if (ev.keyCode == 27) {
                closeSearch();
            }
        });
        document.querySelector('.search').classList.remove('is-hidden');
    }

    function openSearch() {
        searchContainer.querySelector('.search__input').focus();
        mainContainer.classList.add('main-wrap--hide');
        document.querySelector('.search').classList.add('search--open');
    }

    function closeSearch() {
        mainContainer.classList.remove('main-wrap--hide');
        document.querySelector('.search').classList.remove('search--open');
    }

    init();

})(window);

